<template>
    <div ref="container" >
        <vs-popup :active.sync="open" :title="$t('AssignedUser')">
            <vs-select autocomplete v-model="data">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in $store.getters.companyUsers" />
            </vs-select>
        </vs-popup>

    </div>

</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        data () {
            return {
                data: 0,
                open: false
            }
        },
        methods: {
            getValue() {
                return this.data;
            },
            isCancelBeforeStart(){
                if(this.data !== 0) return true;
                if(!this.$checkPermission(106)) return true;
            },
        },
        watch:{
            data: function () {
                if(this.open){
                    this.open = false;
                    Vue.nextTick(() => {
                        this.params.api.stopEditing();
                    });
                }
            },
            open: function () {
                if(!this.open){
                    Vue.nextTick(() => {
                        this.params.api.stopEditing();
                    });
                }
            }
        },
        created() {
            this.data = this.params.data.company_user_id
        },
        mounted() {
            Vue.nextTick(() => {
                this.open = true;
                //this.$refs.container.focus();

            });
        }
    });

</script>
